import { debounce } from 'lodash';
import { useState, useMemo, useEffect, useCallback } from 'react';
import {
  useSearchPatient,
  options,
} from 'components/organisms/rpm-ccm-navigation-header/hooks/use-search-patient';

import type { ModuleType } from 'infrastructure/enums';

interface Props {
  module: ModuleType;
}

const DEFAULT_FILTER = options[0];

export const usePatientAutocomplete = ({ module }: Props) => {
  const [searchKey, setSearchKey] = useState(DEFAULT_FILTER.value);
  const [searchValue, setSearchValue] = useState('');

  const { search, dataOptions, isLoading } = useSearchPatient({ module });

  const placeholder = useMemo(
    () => options.find((o) => o.value === searchKey)?.placeholder,
    [searchKey],
  );
  const debounceSearch = useCallback(debounce(search, 800), []);

  useEffect(() => {
    setSearchValue('');
  }, [searchKey]);

  return {
    debounceSearch,
    dataOptions,
    isLoading,
    placeholder,
    options,
    DEFAULT_FILTER,
    searchValue,
    searchKey,
    setSearchKey,
    setSearchValue,
  };
};
